import { useParams } from 'react-router-dom';
import { EyeExaminationPage } from './EyeExaminationPage';

/** One page per record: opening an amendment from its original, or the other way round, starts from that record and never carries the last one's screen state. */
export function EyeExaminationRoute() {
  const { examinationId } = useParams();
  return <EyeExaminationPage key={examinationId ?? 'new'} />;
}
